// components/Notifications/NotificationTabs.jsx
import React from "react";
import { Tabs, Tab } from "@mui/material";

const NotificationTabs = ({ activeTab, onTabChange, totalCount, unreadCount }) => {
  return (
    <Tabs
      value={activeTab}
      onChange={(e, newValue) => onTabChange(newValue)}
      sx={{
        mt: 0.5,
        minHeight: 28,
        "& .MuiTab-root": {
          minHeight: 28,
          fontSize: "0.7rem",
          fontWeight: 600,
          textTransform: "none",
          px: 1,
        },
      }}
    >
      <Tab label={`All (${totalCount})`} />
      <Tab label={`Unread (${unreadCount})`} />
    </Tabs>
  );
};

export default NotificationTabs;